import { figures } from "../../constants";

const INITIAL_STATE = {
  articleName: null,
  isPrototype: false,
  grade: 3,
  figure: [figures["cylinder"]],
  selected_figure: "cylinder",
  hard_coat: 3,
  hardness_required: 4
};

const articlesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_NAME":
      return { ...state, articleName: action.name };
    case "SET_GRADE":
      return { ...state, grade: action.grade };
    case "SET_PROTOTYPE":
      return { ...state, isPrototype: action.isPrototype };
    case "UPDATE_HARD_COAT":
      return { ...state, hard_coat: action.value };
    case "UPDATE_HARDNESS_REQUIRED":
      return { ...state, hardness_required: action.value };
    case "SET_SELECTED_FIGURE":
      return {
        ...state,
        selected_figure: action.figureName,
        figure: [figures[action.figureName]]
      };
    case "UPDATE_SELECTED_FIGURE_VALUE":
      return { ...state, figure: action.figure };
    case "SAVE_DATA":
      return (state = INITIAL_STATE);
    case "NEW_STATE":
      return (state = action.state);
    case "RESET_STATE":
      return (state = INITIAL_STATE);
    default:
      return state;
  }
};

export default articlesReducer;
